import dayjs, { Dayjs } from 'dayjs'

import { nullDate } from '@/libs/helpers'
import i18n from '@/libs/i18n'

const { t } = i18n.global

const formatDate = (date: Date | number | string, { showTime = false, showSeconds = false } = {}) => {
    const formatToken = showTime ? (showSeconds ? 'YYYY/MM/DD, HH:mm:ss' : 'YYYY/MM/DD, HH:mm') : 'YYYY/MM/DD'
    return dayjs(date).format(formatToken)
}

export const isDateNull = (date: Date | number | string) => {
    return dayjs(date).format('YYYY-MM-DD') === nullDate
}

export interface DurationStruct {
    days: number
    hours: number
    minutes: number
    seconds: number
    formattedString: string
}

export const getDuration = (start: Dayjs, end: Dayjs): DurationStruct => {
    const getEnd = isDateNull(end.toISOString()) ? dayjs() : end
    const dateDifference = getEnd.diff(start, 's', true)

    const days = Math.floor(dateDifference / (60 * 60 * 24))
    const hours = Math.floor(dateDifference / (60 * 60)) - (days * 24)
    const minutes = Math.floor(dateDifference / 60) - ((hours * 60) + (days * 24 * 60))
    const seconds = Math.round(dateDifference) - ((minutes * 60) + (hours * 60 * 60) + (days * 24 * 60 * 60))

    let formattedString = ''
    if (days > 0) {
        formattedString = `${days}${t('general.day', days)}`
    }

    formattedString = `${formattedString} ${hours}${t('general.h')} ${minutes}${t('general.min')} ${seconds}${t('general.sec')}`

    return { days, hours, minutes, seconds, formattedString }
}

export default dayjs
export { formatDate }
